module.exports = __webpack_public_path__ + "f42220fd5de7442a76adeb0af5af13d6.svg";